<div class="product-buttons-panel" >  
  <!-- Not implemented so hide it for demo etc, TODO-->
  <product-button *ngIf="false"></product-button>
</div>